<template>
  <div class="contentHome">
    <div class="centerPage">
      <div class="left">
        <div class="type">
          <p v-for="(obj,index) in helpType" :key="index" :class="active==index?'activeClass':''"
             @click="change(index,obj)">
            <span>{{ obj }}</span>
            <img src="../../assets/img/activeImg.png" alt="" width="17" v-show="active==index">
          </p>
        </div>
      </div>
      <div class="right">
        <div class="desc">
          <template v-if="title=='医生注册'">
            <resHelp></resHelp>
          </template>
          <template v-else-if="title=='心理咨询'">
            <consultation></consultation>
          </template>
          <template v-else-if="title=='私信聊天'">
            <chatDoctor></chatDoctor>
          </template>
          <template v-else-if="title=='预约设置'">
            <appointSet></appointSet>
          </template>
          <template v-else-if="title=='修改申请'">
            <apply></apply>
          </template>
          <template v-else-if="title=='修改预约'">
            <appointment></appointment>
          </template>
          <template v-else-if="title=='咨询历史'">
            <historyConsultation></historyConsultation>
          </template>
          <template v-else-if="title=='优惠券管理'">
            <couponDoctor></couponDoctor>
          </template>
          <template v-else-if="title=='BANNER管理'">
            <bannerEdit></bannerEdit>
          </template>
          <template v-else-if="title=='文章管理'">
            <articleDoctor></articleDoctor>
          </template>
          <template v-else-if="title=='测试分析'">
            <testAnalysis></testAnalysis>
          </template>
          <template v-else-if="title=='账号管理'">
            <editInfo></editInfo>
          </template>
          <template v-else-if="title=='绑定微信'">
            <bingWechat></bingWechat>
          </template>
          <template v-else-if="title=='绑定微信'">
            <bingWechat></bingWechat>
          </template>
          <template v-else-if="title=='收藏小程序'">
            <collection></collection>
          </template>
          <template v-else-if="title=='结账单'">
            <statement></statement>
          </template>
        </div>
      </div>
    </div>
    <el-backtop target=".contentHome" :bottom="100" :visibility-height="10">
      <div
          style="{
        height: 100%;
        width: 100%;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa;
      }"
      >
        UP
      </div>
    </el-backtop>
  </div>
</template>

<script>
import resHelp from './doctor/resHelp'
import consultation from './doctor/consultation'
import appointSet from './doctor/appointSet'
import apply from './doctor/apply'
import appointment from './doctor/appointment'
import historyConsultation from './doctor/historyConsultation'
import couponDoctor from './doctor/couponDoctor'
import bannerEdit from './doctor/bannerEdit'
import chatDoctor from './doctor/chatDoctor'
import articleDoctor from './doctor/articleDoctor'
import testAnalysis from './doctor/testAnalysis'
import editInfo from './doctor/editInfo'
import bingWechat from './bingWechat'
import collection from './collection'
import statement from './doctor/statement'

export default {
  name: "doctorHelp",
  data() {
    return {
      helpType: ["医生注册", "心理咨询", "私信聊天", "预约设置", "修改申请", "修改预约", "咨询历史","结账单", "优惠券管理", "BANNER管理", "文章管理", "测试分析",
        "账号管理", "绑定微信", "收藏小程序"],
      active: 0,
      title: ''
    }
  },
  mounted() {
    this.title = this.helpType[this.active]
  },
  components: {
    resHelp, consultation, appointSet,
    apply, appointment, historyConsultation,
    couponDoctor, bannerEdit, chatDoctor,
    articleDoctor, testAnalysis, editInfo,
    bingWechat, collection,statement
  },
  methods: {
    change(index, tit) {
      this.active = index;
      this.title = tit
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/helpCenter.scss";
</style>
